import React from 'react';

import LogoStacked from './logo/logo-stacked.png';

const LogoIcon = () => {
  return (
    <img
      style={{ marginTop: 15, marginLeft: 22 }}
      alt="Backstage"
      height={58}
      src={LogoStacked}
    />
  );
};

export default LogoIcon;
